export default __webpack_public_path__ + "media/images/footer/pix-794c0c9d2894dd1062f3eb8d1ae87cbe.svg";